import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.colors.teal,
    color: theme.palette.colors.white,
  },
  medium: {
    width: 128,
    height: 128,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/UserImage/useStyles.js